export function ConfirmIMC(title,html) {
    if(title == undefined) {
        title = "IMC confirm";
    }

    if(html == undefined) {
        html = "";
    }

    return new Promise((resolve, reject) => {
        EventBus.$emit("show_imc_confirm",
            {
                "title": title,
                "html": "",
                worker : {
                    resolve : resolve,
                    reject : reject
                }
            });
    });

}
